// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__SOne3","disabled":"FileBtn_disabled__1DaCW","warn":"FileBtn_warn__1QyPQ","fade":"FileBtn_fade__1cWkk"};